import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const evapotranspirationETo: typeof valueTypeRenderers.evapotranspirationETo = {
  label: () =>
    translate.phrases.templates('{{labelA}} ({{labelB}})', {
      labelA: unitConverter.evapotranspiration().titleWithoutUnit(),
      labelB: translate.phrases.unitSymbols('ETo'),
    }),
  block: () => {
    const { suffix, shortTitle } = unitConverter.evapotranspiration()
    const label = twoItemLabel([`${shortTitle()} ${translate.phrases.unitSymbols('ETo')}`, suffix()])

    return (v) => [
      {
        id: 'value',
        value: unitConverter.evapotranspiration(v).valueAsString(),
        label,
      },
    ]
  },
}
